import { jwtDecode } from "jwt-decode";

export const TENANT_ADMIN_ROLE = "ROLE_ADMIN";
export const EMPLOYEE_ROLE = "ROLE_EMPLOYEE";

const normaliseRoles = (value) => {
  if (Array.isArray(value)) return value.flatMap(normaliseRoles);
  if (typeof value === "string") return value.split(/[\s,]+/).filter(Boolean);
  if (value && typeof value === "object") {
    return normaliseRoles(value.authority ?? value.role ?? value.name);
  }
  return [];
};

export const getTokenRoles = (token) => {
  if (!token) return [];
  try {
    const claims = jwtDecode(token);
    return [
      ...normaliseRoles(claims.roles),
      ...normaliseRoles(claims.authorities),
      ...normaliseRoles(claims.role),
      ...normaliseRoles(claims.scope),
    ];
  } catch (error) {
    return [];
  }
};

export const isTenantAdmin = (token) =>
  getTokenRoles(token).includes(TENANT_ADMIN_ROLE);

export const isEmployee = (token) =>
  getTokenRoles(token).includes(EMPLOYEE_ROLE);
